import {ID, Resource} from 'simpli-web-sdk'
import DeliverySlaResponseSchema from '@/schema/DeliverySlaResponse.schema'

export default class DeliverySlaResponse extends Resource {

  readonly $name: string = 'DeliverySlaResponse'
  readonly $endpoint: string = '/user/indicador/entrega-sla'

  get $schema() {
    return DeliverySlaResponseSchema(this)
  }

  $id = 0
  nome: string | null = null
  documento: string | null = null
  dentroSLA: number | null = null
  foraSLA: number | null = null
  naoInformadoSLA: number | null = null

  porcentagemDentroSLA: number | null = null
  porcentagemForaSLA: number | null = null
  porcentagemNaoInformadoSLA: number | null = null
}
